<template>
  <div class="impot-revenu-list">
    <!-- La barre d'action -->
    <PageHeader
      title="Calculateur d'impôt revenu"
      :has-actions="true"
      :has-back="true"
      @back="goBack"
    >
      <md-button
        class="md-primary md-raised"
        @click="$router.push('/admin/calculators/impot-revenu/create')"
      >
        Ajouter un impôt revenu
      </md-button>

      <md-button
        class="md-primary md-raised"
        @click="$router.push('/admin/calculators/impot-revenu/history')"
      >
        Histoire
      </md-button>
    </PageHeader>

    <!-- La liste des calculators -->
    <sortable-list
      link="/admin/calculators/impot-revenu/update/"
      :items="data"
      :parameters="listParameters"
      :hasPagination="true"
    >
    </sortable-list>
  </div>
</template>

<script>
import calculatorsModel from "../../../../model/calculators";
import PageHeader from "@/components/PageHeader";

export default {
  components: { PageHeader },
  data() {
    return {
      isDebug: false,
      data: [],
      listParameters: [
        {
          name: "Montant",
          key: "montant",
        },
        {
          name: "Coefficiant",
          key: "coef",
        },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.push("/admin/calculators/");
    },
  },
  mounted() {
    calculatorsModel.getAllRevenu().then((data) => {
      this.data = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.impot-revenu-list {
  .debug-log {
    max-height: 200px;
    overflow-y: scroll;
  }
}
</style>
